var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-easy-table"},_vm._l((_vm.fields),function(field,fieldKey){return _c('WsEasyTableItem',{key:fieldKey,attrs:{"field":field,"modelData":_vm.modelData,"value":_vm.$_getValueByFieldKey(fieldKey)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }